import React, { Component } from 'react';

import Title from './Title.jsx';
import Header from './Header.jsx';
import Table from './Body.jsx';


class PermisosPorPerfl extends Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        const id = this.props.match.params.id;
        this.props.getScreenData(id, this.props.currentScope);
    }

    componentWillUnmount() {
        this.props.resetStatePerPorPerf();
    }

    render() {
        const { data } = this.props;
        let spinner = null;

        if (data && data.permisosPorPerfil) {

            if (this.props.data.isFetching == true)
                spinner = <div className="loading">Loading&#8230;</div>

            if (data.isFetching != true) {
                return (
                    <div className="container-fluid concierge">
                        <Title titulo1={'Permisos del perfil '}
                            titulo2={this.props.data.title2} /> 
                        <Header functions={data.functions} />
                        <Table data={data} />
                    </div>
                );
            }
            else {
                return spinner;
            }
        } else {
            return null;
        }
    }
}

export default PermisosPorPerfl;